export const logoPlaceholder = '{X}';
export const texts = {
  NAMESPACE: 'Wix_Ads',
  MAIN_TEXT_LIVE_KEY: 'studio_banner_text',
  MAIN_TEXT_LIVE_DEFAULT: 'Built on',
} as const;
